// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ReportDeliveryWidget__Component[data-v-0413a948] {\n  width: 100%;\n}\n.ReportDeliveryWidget__Component .ReportDeliveryWidget__Component__Status[data-v-0413a948] {\n    border: 1px solid #e4eaf1;\n    background-color: #eef1f3;\n    border-radius: 3px;\n    display: flex;\n    border-radius: 3px;\n    padding: 2px 10px;\n}\n.ReportDeliveryWidget__Component .ReportDeliveryWidget__Component__Status span[data-v-0413a948] {\n      margin: 0 2px;\n      display: block;\n}\n", ""]);
// Exports
module.exports = exports;
